import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Col, Row, Spin } from "antd";
import { FileUnknownOutlined, LeftCircleOutlined } from "@ant-design/icons";
// import moment from "moment";
//components
import { DescargaFormatos } from "../../../components/Admin/Aspirante";
import { ListaAcademica } from "../../../components/Admin/Aspirante";
import { CargaArchivos } from "../../../components/Admin/Aspirante";
import { ListaArchivos } from "../../../components/Admin/Aspirante";
import { ListaArchivoSubir } from "../../../components/Admin/Aspirante";
import * as ducks from "../../../redux/aspirante/expDigitalDucks";
//utils
import { AlertGeneric, EXP_ARCHIVO } from "../../../utils";
import { ReactComponent as Indicaciones } from "../../../assets/img/admin/IndicaciónInfoLab.svg";
import * as utils from "../../../utils";
import { linksRouter } from "../../../config/RouterLink";
import { ModalDetalle } from "../../../components/Admin/Aspirante/Expediente/ModalDetalle";
import { ModalRequerimiento } from "../../../components/Admin/Aspirante/Expediente/ModalRequerimiento";
import { getValorParametro } from "../../../redux/aspirante/catalogoDucks";

/**
 * Página que muestra el módulo del expediente digital. 
  @return {JSX.Element}
  @author Uriel Carrión  
 */
const ExpedientePage = (props) => {
  const { aspirante } = props.location;
  const isMounted = useRef(true);
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [mensajeFecha, setMensajeFecha] = useState("");
  const { tipoDocumentos, tipoDocumentosCopia } = useSelector(
    (state) => state.expDigital
  );
  const { bloquearPorFecha } = useSelector(
    (state) => state.bloqueoEstatus.expediente
  );
  const concurso = useSelector(
    (state) => state.bloqueoEstatus.expediente.concurso
  );
  const { loading, listaArchivosPorSubir } = useSelector(
    (state) => state.expDigital
  ); //validarExpediente
  const { isSaved, isError, mensaje } = useSelector(
    (state) => state.expDigital.formulario
  );
  //useEffect que valida si el componente está montado en la App.
  useEffect(() => {
    dispatch(ducks.cleanExpDigital());
    dispatch(ducks.getEstatusExpediente());
    return () => {
      isMounted.current = false; //Desmontar el componente
      dispatch(ducks.cleanExpDigital());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tipoDocumentosCopia.length < 1) {
      dispatch(getValorParametro(utils.FECHA_EXPEDIENTE)).then(({ data }) => {
        setMensajeFecha(data.valorConfig);
      });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    //Se llena el combo de Tipo de documento
    if (aspirante) {
      dispatch(ducks.getCatDocumentos(2, aspirante.idConcurso)); //Formatos de descarga
      dispatch(
        ducks.validarExpediente(aspirante.idConcurso, aspirante.idConvocatoria)
      );
      //Cambio con un nuevo formato
      dispatch(ducks.getCatDocumentos(3, aspirante.idConcurso)); //Catalogo de los documentos a subir
      // console.log(idConcurso, idConvocatoria);
      if (concurso?.idConcurso && concurso?.idConvocatoria) {
        setDisabled(
          aspirante.idConcurso === concurso.idConcurso &&
            aspirante.idConvocatoria === concurso.idConvocatoria
        );        
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //useEffect que valida si hubo un error al registrar el documento o se guardó correctamente.
  useEffect(() => {
    isMounted.current && validaFormulario();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, isSaved, mensaje]);

  /**
   * Función que muestra los mensajes de acuerdo a la respuesta del service.
   */
  const validaFormulario = () => {
    if (isSaved) {
      utils.openModalSucces("Éxito", mensaje); //Muestra el modal
      dispatch(ducks.setFormularioClean()); // Se limpia el state de mensajes
      window.scrollTo(0, 0);
    }
    if (isError) {
      const { idConcurso, idConvocatoria } = aspirante;
      utils.openModalError(utils.ERROR, mensaje);
      dispatch(ducks.setFormularioClean()); // Se limpia el state de mensajes

      aspirante &&
        dispatch(ducks.getCatDocumentos(1, idConcurso, idConvocatoria));
    }
  };

  // const isValidoExpediente = () => {
  //   const { fechaInicio, fechaFin } = validarExpediente;
  //   const hoy = new Date(moment().format(utils.DATE_FORMAT_EXP));
  //   const startDate = new Date(
  //     moment(fechaInicio).format(utils.DATE_FORMAT_EXP)
  //   );
  //   const endDate = new Date(moment(fechaFin).format(utils.DATE_FORMAT_EXP));

  //   //Si la fecha actual es menor a la fecha inicio se bloquea el botón
  //   if (hoy < startDate) return true;
  //   //Si la fecha actual es igual o mayor a la fecha inicio y no existe fecha fin se habilita el botón
  //   if (hoy >= startDate && isNaN(endDate.getTime())) {
  //     return false;
  //   }
  //   //Si la fecha actual se encuentra en el rango de las fechas inicio y fin se habilita el botón
  //   //Si ya pasaron las fechas y el estatus se encuentra en 1, solo se bloquea el botón
  //   return hoy >= startDate && hoy <= endDate ? false : true;
  // };

  //Redirecciona a la pantalla pricipal en caso de que no exista información en la variable aspirante
  // if (!aspirante || isValidoExpediente()) {
  if (!aspirante) {
    // utils.openNotification("warning", utils.ERROR, utils.ERROR_EXPEDIENTE);
    return <Redirect to={linksRouter.postulaciones} />;
  }
  // console.log(disabled);
  return (
    <div className="layout-content-public">
      {/* ---------------------- MODALS --------------------------- */}
      <ModalDetalle />

      <Spin size="large" spinning={loading}>
        <div className="expediente-content">
          <div style={{ marginBottom: 20, marginTop: 20 }}>
            <Link to={linksRouter.postulaciones} className="link">
              <LeftCircleOutlined /> Regresar
            </Link>
          </div>
          <h2>Integración de documentos</h2>

          <Row gutter={24}>
            <Col span={12} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <div className="exp-formato-fondo">
                {/* -------------------- Documentos de protesta --------------------- */}
                <DescargaFormatos />
              </div>

              {/* ----------------- Textos Informativos ----------------------- */}
              <div style={{ marginTop: 30 }}>
                <AlertGeneric type="info" message={EXP_ARCHIVO} />
              </div>

              <Row style={{ marginTop: 30 }}>
                <Col span={1} xxl={1} xl={1} lg={1} md={1} sm={24} xs={24}>
                  <div className="exp-vineta"></div>
                </Col>
                <Col span={23} xxl={23} xl={23} lg={23} md={23} sm={24} xs={24}>
                  Único formato válido: <b>PDF</b>
                </Col>
              </Row>
              <Row>
                <Col span={1} xxl={1} xl={1} lg={1} md={1} sm={2} xs={2}>
                  <div className="exp-vineta"></div>
                </Col>
                <Col span={23} xxl={23} xl={23} lg={23} md={23} sm={24} xs={24}>
                  Peso máximo por archivo: <b>15MB</b>
                </Col>
              </Row>

              <Row>
                <div className="contenedor-sin-datos exp-formato-fondo">
                  <Col xxl={3} xl={3} lg={3} md={3} sm={3} xs={3}>
                    <Indicaciones />
                  </Col>
                  <Col xxl={20} xl={20} lg={20} md={20} sm={24} xs={24}>
                    <div className="">
                      Elige una opción de tipo de documento, presiona adjuntar y
                      selecciona el documento deseado. Repite este proceso hasta
                      terminar con todos los documentos solicitados.
                    </div>
                  </Col>
                </div>
              </Row>
              {/* --------------- Modal de Requerimientos (Sprint 9)-------------------------- */}
              <ModalRequerimiento />
              {/* ---------------------- Carga de Documentos ------------------------------------- */}
              {/* (Sprint 9) */}
              {tipoDocumentosCopia.length < 1 ? (
                // -------------------Cuando ser termina de capturar todoslos documentos-------------------------------------
                <AlertGeneric type="success" message={mensajeFecha} />
              ) : (
                !bloquearPorFecha &&
                disabled && (
                  <AlertGeneric
                    type="warning"
                    message={utils.DOCUMENTOS_EXP_INFO}
                  />
                )
              )}
              {/* Fin (Sprint 9) */}
              {!bloquearPorFecha && disabled && (
                <>
                  <CargaArchivos aspirante={aspirante} />
                  <div style={{ marginTop: 0 }}>
                    {tipoDocumentos.length >= 1 && <p>Adjunto del aspirante</p>}
                    {/* ----------------- Documentos a subir -------------------------- */}
                    {listaArchivosPorSubir.length > 0 ? (
                      <ListaArchivoSubir />
                    ) : (
                      tipoDocumentos.length >= 1 && (
                        <>
                          <FileUnknownOutlined /> Sin documento
                        </>
                      )
                    )}
                  </div>{" "}
                </>
              )}
            </Col>

            {/* --------------------- Lista de Documentos del Aspirante ------------------------- */}
            <Col span={12} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <div style={{ marginBottom: 15 }}>
                <ListaAcademica />
              </div>
              <ListaArchivos aspirante={aspirante} />
            </Col>
          </Row>
        </div>
      </Spin>
    </div>
  );
};

export default withRouter(ExpedientePage);
